import SistemaGestao from './SistemaGestao';

function App() {
  return <SistemaGestao />;
}

export default App;